import {NgZone} from '@angular/core';
import {MonoTypeOperatorFunction, Observable} from 'rxjs';

// @angular/fire 20 compat schedules Firestore emissions on its outsideAngular scheduler
// and never re-enters the zone (valueChanges/snapshotChanges only pipe pendingUntilEvent,
// which handles app stability, not change detection). A snapshot arriving after the app
// is stable then updates component state without any CD pass. On slow devices the
// /reserveer spinner froze exactly like this until the next user event or a refresh.
// Re-enter the zone at the service boundary so every emission schedules change detection.
export function observeInZone<T>(zone: NgZone): MonoTypeOperatorFunction<T> {
  return (source) => new Observable<T>((subscriber) => {
    const subscription = source.subscribe({
      next: (value) => zone.run(() => subscriber.next(value)),
      error: (err) => zone.run(() => subscriber.error(err)),
      complete: () => zone.run(() => subscriber.complete()),
    });
    return () => subscription.unsubscribe();
  });
}
